import styled, { css, DefaultTheme } from 'styled-components';
import { Field as UnstyledField } from 'formik';

type ContentProps = {
  required?: boolean;
};

type FeedbackMessageProps = {
  error: boolean;
};

type CheckmarkProps = {
  error: boolean;
};

export const Label = styled.label`
  display: block;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    padding-left: 30px;
    width: 100%;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:hover input ~ span {
      background-color: ${theme.colors.neutralGray5};
    }

    & input:checked ~ span {
      background-color: ${theme.colors.primary70};
    }

    & input:checked ~ span:after {
      display: block;
    }
  `}
`;

const fieldModifiers = {
  required: (theme: DefaultTheme) => css`
    &::after {
      content: '*';
      vertical-align: middle;
      color: ${theme.colors.statusDanger50};
    }
  `,
};

export const Field = styled(UnstyledField)`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const Checkmark = styled.span<CheckmarkProps>`
  ${({ theme, error }) => css`
    position: absolute;
    top: 5px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: ${theme.colors.globalWhite100};
    border: ${error ? 2 : 1}px solid
      ${error ? theme.colors.statusDanger40 : 'rgba(102, 102, 102, 0.24)'};
    border-radius: 4px;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      display: none;
    }

    &:after {
      left: 7px;
      top: 3px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  `}
`;

export const Content = styled.p<ContentProps>`
  ${({ theme, required }) => css`
    font-size: 1.6rem;
    font-weight: 300;
    color: ${theme.colors.neutralDark90};
    line-height: 24px;

    ${required && fieldModifiers.required(theme)}

    strong {
      font-weight: 700;
      color: ${theme.colors.statusInfo50};
    }
    span {
      font-weight: 700;
    }
  `}
`;

export const FeedbackMessage = styled.span<FeedbackMessageProps>`
  ${({ theme, error }) => css`
    font-weight: 400;
    font-size: 14px;

    display: block;
    margin-top: 0.4rem;

    color: ${error
      ? theme.colors.statusDanger40
      : theme.colors.statusSuccess50};
  `};
`;
